import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Inventory_ds_lots_by_licenseplate_ddService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { licenseplateId?: number, materialId?: number, vendorlotId?: number, fullTextSearch?: string }): 
  Promise<{ result: { LookupCode?: string, LotId?: number }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { licenseplateId?: number, materialId?: number, vendorlotId?: number, fullTextSearch?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { LookupCode?: string, LotId?: number }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { licenseplateId?: number, materialId?: number, vendorlotId?: number, fullTextSearch?: string, $keys: number[] }): 
  Promise<{ result: { LookupCode?: string, LotId?: number }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      licenseplateId?: number, materialId?: number, vendorlotId?: number, fullTextSearch?: string    }) {
      return false;
    }
}
